import React from 'react';
import Icon from '../../ui/icon/icon';
import Button from '../../ui/button/button';
import './message.css';
import {parsedHTML} from "../../../resale/buyer/components/utils";

const MessageIcon = {
    'info': 'infoCircle',
    'success': 'check',
    'warning': 'exclamationYellow',
    'danger': 'exclamationRed',
}


export function ConfirmMessage({config, onSubmit}) {
    const message = config.confirm_message;

    if (!message) {
        return null;
    }
    return <Message type={message.type} title={message.title} description={message.body} action_button={message.action_button} ctaLabel={message.action_button?.title} onSubmit={onSubmit}/>
}

export function InfoMessage({config}) {
    const message = config.form_instructions;

    if (!message) {
        return null;
    }
    return <Message type={message.type} title={message.title} description={message.body}/>
}

export function ErrorMessage({config}) {
    const error = config.error_messages;

    if (!error) {
        return null;
    }
    return <Message title={error.title} description={error.body} type='danger' />
}

export default function Message({ title, description, ctaLabel, type, action_button, children, onSubmit = () => { } }) {
    // info, success, warning, danger

    const onCTAClick = () => {
        onSubmit({
            data: {
                action: action_button?.action,
            }
        })
    }

    return (
        <div className={`neo-message neo-message-${type}`}>
            <div className='neo-message-left neo-message-content'>
                {title && <h3 className='neo-message-title'>
                    <Icon className={MessageIcon[type] === 'infoCircle' ? 'neo-message-info-icon' : ''} name={MessageIcon[type]} />{title}
                </h3>}
                {description && <p className='neo-message-description'>{parsedHTML(description)}</p>}
                {children && <p className='neo-message-description'>{children}</p>}
            </div>
            {
                action_button && (
                    <div className='neo-message-right'>
                        <Button type={type} label={ctaLabel} onClick={onCTAClick}/>
                    </div>
                )
            }
        </div>
    )
}
